import { useCallback, useEffect, useState } from 'react';
import * as providerAdminApi from '../../../api/providerAdminApi';
import { useAuth } from '../../../auth/AuthProvider';
import { DataTable } from '../../../components/ui/DataTable';
import { canAccessProviderAdmin } from './providerAdminAccess';

export function RolesPage() {
  const { session } = useAuth();
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const allowed = canAccessProviderAdmin(session);

  const load = useCallback(async () => {
    setError(null);
    try {
      const rows = await providerAdminApi.listRoles();
      setItems(Array.isArray(rows) ? rows : []);
    } catch (err) {
      setError(err.message || 'Failed to load roles');
      setItems([]);
    }
  }, []);

  useEffect(() => {
    if (allowed) load();
  }, [allowed, load]);

  if (!allowed) {
    return <p className="text-sm text-eorig-muted">Provider Admin access is required.</p>;
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-eorig-muted">System role catalog. Custom roles are out of scope for MVP.</p>
      {error ? <p className="text-sm text-red-600">{error}</p> : null}
      <DataTable
        columns={[
          { key: 'org_type', header: 'Org type' },
          { key: 'code', header: 'Role' },
          { key: 'label', header: 'Label' },
          { key: 'purpose', header: 'Purpose' },
        ]}
        rows={items}
        rowKey={(row) => `${row.org_type}-${row.code}`}
        emptyMessage="No roles returned."
      />
    </div>
  );
}
